<template>
  <ul>
    <li v-for="(item, index) in infoList" @click="detailId(item)">
      <p class="sort">{{ item.sort }}</p>
      <p class="hot">
        <img
          src="http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/%E7%81%AB.png"
          alt=""
        />
        热度指数：{{ item.hot }}
      </p>
      <img class="bg" :src="item.bg" alt="" />
      <p class="name">{{ item.name }}</p>
      <div class="des-box">
        <div v-html="item.des"></div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: '',
  props: {
    infoList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    detailId(item) {
      if (this.$api.kernel() === 'wx') {
        this.$router.push({
          name: 'headlineDetail',
          params: { id: item.id },
          query: { type: 0 }
        });
      } else {
        this.$emit('detail-id', item.id);
      }
    }
  },
  computed: {},
  components: {},
  created() {}
};
</script>
<style lang="less" scoped>
li {
  * {
    color: #fff;
    line-height: 1.3;
  }
  .sort {
    font-size: 0.8rem /* 60/75 */;
    text-align: center;
    margin-top: 0.5333rem /* 40/75 */;
  }
  .hot {
    background-image: linear-gradient(-179deg, #513ad8 0%, #8269ee 100%);
    box-shadow: 0 0.0533rem /* 4/75 */ 0.1333rem /* 10/75 */ -1px #1d2f90;
    width: 3.2267rem /* 242/75 */;
    height: 0.4667rem /* 35/75 */;
    line-height: 0.4667rem /* 35/75 */;
    text-align: center;
    margin: auto;
    border-radius: 1.3333rem /* 100/75 */;
    color: #fffc00;
    margin-top: 0.06rem /* 3/75 */;
    margin-bottom: 0.3733rem /* 28/75 */;
    img {
      width: 0.35rem /* 15/75 */;
    }
  }
  .bg {
    margin-bottom: 0.2133rem /* 16/75 */;
  }
  .name {
    font-size: 0.4533rem /* 34/75 */;
    margin-bottom: 0.3733rem /* 28/75 */;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .des-box {
    padding: 0.4rem /* 30/75 */ 0.48rem /* 36/75 */;
    background-color: rgba(104, 98, 238, 0.34);
    div {
      color: #97baff;
      line-height: 1.5;
    }
  }
}
</style>
